import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

export type ResolvedUserContext = {
    CustomerId?: string;
    Email: string;
    UserId?: string;
    fullname: string;
};

/**
 * Dependency-free bridge for consumers that react to resolved user identity.
 * Keeping this separate prevents telemetry consumers from constructing the
 * resolver that reports errors through telemetry.
 */
@Injectable({ providedIn: 'root' })
export class UserContextService {
    private readonly _userContext = signal<ResolvedUserContext | null>(null);

    readonly userContext = this._userContext.asReadonly();
    readonly userContext$ = toObservable(this.userContext).pipe(
        filter((userContext): userContext is ResolvedUserContext => userContext !== null)
    );

    publish(userContext: ResolvedUserContext): void {
        this._userContext.set(userContext);
    }
}
